"use client";

function extractYouTubeId(idOrUrl) {
    if (!idOrUrl) return "";
    try {
        const url = new URL(idOrUrl);
        if (url.hostname === "youtu.be") return url.pathname.slice(1);
        if (url.pathname.startsWith("/embed/"))
            return url.pathname.replace("/embed/", "");
        return url.searchParams.get("v") || "";
    } catch {
        return idOrUrl;
    }
}

export default function Youtube({
    id,
    start = 0,
    title = "YouTube video",
    className = "",
    ...props
}) {
    const videoId = extractYouTubeId(id);
    if (!videoId) {
        return (
            <div className="bg-red-100 text-red-700 rounded p-3 my-4">
                Invalid YouTube ID or URL.
            </div>
        );
    }

    const embedUrl = `https://www.youtube.com/embed/${videoId}${
        start ? `?start=${start}` : ""
    }`;

    return (
        <div
            className={`aspect-video my-4 rounded overflow-hidden bg-black ${className}`}
        >
            <iframe
                src={embedUrl}
                title={title}
                className="w-full h-full"
                frameBorder="0"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                {...props}
            />
        </div>
    );
}
